<template>
  <div id="buttonDiv">
  </div>
</template>

<script>
export default {
  name: 'GoogleSignIn',
  props: {
    signUp: {type:Boolean, required:false, default:false},
    query: {type:Object, required:true}

  },

  async mounted() {
    if (!window.google?.accounts) {
      const script = document.createElement('script');
      script.src = 'https://accounts.google.com/gsi/client';
      script.async = true;
      const loaded = new Promise((resolve) => {
        script.onload = () => {
          resolve(true);
        }
      })
      document.head.appendChild(script);
      await loaded;
    }
    window.google.accounts.id.initialize({
      client_id: process.env.VUE_APP_GOOGLE_CLIENT_ID,
      callback: this.handleCredentialResponse
    });
    window.google.accounts.id.renderButton(
      document.getElementById("buttonDiv"),
                              { theme: "outline", size: "large" , text: this.signUp ? 'signup_with' : 'signin_with', width:335}
    );
  },
  methods: {
    handleCredentialResponse(response) {
      if (response.clientId === process.env.VUE_APP_GOOGLE_CLIENT_ID) {
        this.$emit('googleIdToken', response.credential)
      }
    }
  }
}
</script>